import React, { useState } from 'react';
import ToLogin from '../common/ToLogin';
import { useContextState } from '../context';
import PersonalLicensesComponent from './PersonalLicensesComponent';
import Spinner from '../common/Spinner';

const PersonalLicenses = () => {
  const { authorized } = useContextState();
  const [loading, setLoading] = useState(true);

  setTimeout(() => {
    setLoading(false);
  }, 500);

  if (loading) {
    return (
      <div className="spinner-licenses">
        <Spinner />
      </div>
    );
  }
  if (authorized) {
    return <PersonalLicensesComponent />;
  }

  return <ToLogin />;
};

export default PersonalLicenses;
